import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {LoaderService, ReportService} from '@app/shared';
import {CommonModule, DecimalPipe} from '@angular/common';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FormsModule} from '@angular/forms';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-stock-value-report',
  templateUrl: './stock-value-report.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DecimalPipe,
    PageHeaderComponent,
    ReportPdfComponent
  ],
  styleUrls: ['./stock-value-report.component.scss']
})
export class StockValueReportComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;

  stock_data: any;
  medicine: any;
  search_text: any;
  total_amount = 0;
  p = 10;
  public collection: any = '';
  page = 1;
  start = 0;
  limit = 10;
  index: any;

  constructor(private loaderService: LoaderService, public report: ReportService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listStockValueReport();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.listStockValueReport();
    }
  }

  public listStockValueReport() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.search_text,
      sale_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.listStockValueReport(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.stock_data = result['data'];
        let total_amount = 0;
        for (const data of this.stock_data) {
          total_amount = total_amount + parseFloat(data.AMOUNT)
        }
        this.total_amount = total_amount
        this.collection = result['total_count'];
        const i = this.stock_data.length;
        this.index = i + 5;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

   public ExportToExcel() {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
        dateNF: 'dd/mm/yyyy;@',
        cellDates: true,
        raw: true
      });
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'Purchase' + new Date().getTime() + EXCEL_EXTENSION);
  
    }
}
